module.exports = __webpack_public_path__ + "img/ukr.e93da517.svg";